import {scrollToId, smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";
import {gsap} from "gsap";
import {breakpointUp} from "../utils/breakpoints";

$(document).ready(function () {
  if ($('.intro-modal').length) {

    smoothScrollPause();
    $('body').addClass('overflow-hidden').css({opacity: 1})
    const sequenceImages = document.querySelectorAll('.sequence img');
    const sequenceStagger = 4 / sequenceImages.length;

    const tl = gsap.timeline({
      onComplete: function () {
        gsap.fromTo(
          '.loading-text .letter', // Target all elements with class .single
          {y: '0%'}, // Initial position (off-screen)
          {
            y: '-100%', // Final position (on-screen)
            duration: 0.5,
            ease: 'power2.inOut',
            stagger: 0.1, // Stagger the animation for each element
            delay: 0.5,
            onComplete: function () {
              gsap.to('.first-screen', {
                opacity: 0,
                display: 'none', // Add display none after animation
                duration: 0.5,
                delay: 0.5,
                ease: 'power2.inOut',
                onComplete: function () {
                  gsap.to('.second-screen .top-block', {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: 'power2.inOut',
                  });
                  gsap.to('.second-screen .video, .second-screen .sequence', {
                    opacity: 1,
                    y: 0,
                    duration: 0.5,
                    delay: 0.15,
                    ease: 'power2.inOut',
                    onComplete: function () {
                      if (breakpointUp('xl')) {
                        $('#intro-video').trigger('play');
                      } else {
                        gsap.to(sequenceImages, {
                          duration: 4, // Animation duration
                          display: 'block',        // Display property to be animated to
                          ease: 'power2.inOut',    // Easing function
                          stagger: sequenceStagger,
                        });
                      }
                      setTimeout(function () {
                        gsap.to('.second-screen', {
                          opacity: 0,
                          duration: 0.3,
                          ease: 'power2.inOut',
                        });

                        gsap.to('.intro-modal .bottom-line', {
                          height: "8rem",
                          duration: 0.1225,
                          ease: 'expoScale(0.5,7,none)',
                          onComplete: function () {
                            gsap.to('.intro-modal .bottom-line', {
                              height: "18rem",
                              duration: 0.2575,
                              ease: 'expoScale(0.5,7,none)',
                              onComplete: function () {
                                gsap.to('.intro-modal .bottom-line', {
                                  height: "5rem",
                                  duration: 0.23,
                                  ease: 'power2.inOut',
                                  onComplete: function () {
                                    gsap.to('.intro-modal .bottom-line', {
                                      height: "1rem",
                                      duration: 0.10,
                                      ease: 'none',
                                      onComplete: function () {
                                        gsap.to('.intro-modal .bottom-line', {
                                          height: "0.02rem",
                                          duration: 0.0905,
                                          ease: 'none',
                                          onComplete: function () {
                                            gsap.to('.intro-modal .bottom-line', {
                                              height: "0",
                                              duration: 0.001,
                                              ease: 'none',
                                            });
                                          }
                                        });
                                      }
                                    });
                                  }
                                });
                              }
                            });
                            gsap.to('.intro-modal', {
                              y: "-100%",
                              duration: 0.75,
                              ease: 'power2.inOut',
                              onComplete: function () {
                                animateHeroBlocks()
                              }
                            });
                            smoothScrollPlay();
                            if (breakpointUp('lg')) {
                              $('#intro-video').trigger('pause');
                            }
                            $('body').removeClass('overflow-hidden');
                          }
                        });
                      }, 4000);
                    }
                  });
                }
              });
            }
          }
        );
      }
    });
    tl.fromTo(
      '.loading-text', // Target all elements with class .single
      {opacity: 0}, // Initial position (off-screen)
      {
        opacity: 1, // Final position (on-screen)
        duration: 0.5,
        ease: 'power2.inOut',
        delay: 0.5,
      }
    );
  } else {
    setTimeout(function () {
      animateHeroBlocks()
    }, 1200);
  }
});


function animateHeroBlocks() {

  gsap.to('.nav-container .nav-links, .nav-container .buttons', {
    opacity: 1,
    y: 0,
    duration: 0.6,
    delay: 0.2,
    ease: 'M0,0 C0.31,0.03 0.58,1 1,1',
  });
  if ($('.block-index-hero').length) {
    gsap.to('.block-index-hero', {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: 'power2.inOut',
    });

  }
  if ($('.history-heroes').length) {
    gsap.to('.history-heroes', {
      opacity: 1,
      duration: 0.5,
      ease: 'power2.inOut',
      onComplete: function () {
        $('.history-heroes .hero-list').addClass('loaded')
      }
    });
  }

  if (window.location.hash) {
    const hash = window.location.hash;
    scrollToId(hash);
  }

}

window.startTimelineGridAnimation = function() {
  if ($('.timeline').length) {
    const timelineItems = document.querySelectorAll('.timeline-single.image-block img');

    timelineItems.forEach(item => {
      gsap.to(
        item,
        {
          opacity: 0,
          scale: 0.8,
          duration: 0.5,
          ease: 'power2.inOut',
        }
      );
    });
  }
}

window.finishTimelineGridAnimation = function() {
  if ($('.timeline').length) {
    const timelineItems = document.querySelectorAll('.timeline-single.image-block img');

    timelineItems.forEach(item => {
      gsap.to(
        item,
        {
          opacity: 1,
          scale: 1,
          duration: 0.5,
          ease: 'power2.inOut',
        }
      );
    });
  }
}
